import {AutoComplete, Flex, Space} from "antd";
import React from "react";
import {countries} from "./countries";

export const CountriesAutoComplete = (
    props: {
        selectedOrigin: string,
        onOriginSelected: (origin: string) => void
    }
) => {
    const origins = countries.map((country) => ({
        key: country.code,
        value: country.name
    }))

    return (
        <AutoComplete
            options={origins}
            defaultValue={props.selectedOrigin}
            style={{width: 200}}
            optionRender={(item) => <Flex justify={"space-between"}>
                <div>{item.value}</div>
                <div>{item.key.toString()}</div>
            </Flex>}
            onSelect={(value) => props.onOriginSelected(value)}
            filterOption={(inputValue, option) =>
                option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 || option!.key.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
            }
        />
    )
}